
export const ADD_USER = "ADD_USER"

export const EDIT_USER = "EDIT_USER"

export const DELETE_USER = "DELETE_USER"

export const SUSPEND_USER = "SUSPEND_USER"

export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS"

export const SIGNUP_USER_ERROR = "SIGNUP_USER_ERROR"

export const SIGNUP_USER = "SIGNUP_USER"